import React from 'react';

interface ChevronIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
  direction?: 'left' | 'right' | 'up' | 'down';
}

const ChevronIcon: React.FC<ChevronIconProps> = ({ 
  className, 
  width, 
  height, 
  fill = "currentColor",
  direction = 'left'
}) => {
  // Transform based on direction
  let transform = '';
  switch (direction) {
    case 'right':
      transform = 'rotate(180 10 10)';
      break;
    case 'up':
      transform = 'rotate(90 10 10)';
      break;
    case 'down':
      transform = 'rotate(270 10 10)';
      break;
    default:
      transform = '';
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
        clipRule="evenodd"
        transform={transform || undefined}
      />
    </svg>
  );
};

export default ChevronIcon; 